import { Component, defineComponent } from '@decify/cell-shopify/client';
import './Video.scss';
export const videoName = 'Video';
export const videoTagName = 'cell-component-video';
export class Video extends Component {
    constructor() {
        super(videoName);
        const videoElement = this.querySelector('video');
        if (!videoElement) {
            throw new Error('Video element not found');
        }
        this.play = this.play.bind(this);
        this.pause = this.pause.bind(this);
        this.reset = this.reset.bind(this);
    }
    play() {
        this.videoElement.play();
    }
    pause() {
        this.videoElement.pause();
    }
    reset() {
        this.videoElement.currentTime = 0;
    }
    showControls() {
        this.videoElement.controls = true;
    }
    hideControls() {
        this.videoElement.controls = false;
    }
    get videoElement() {
        const videoElements = this.querySelectorAll('video');
        // Find the video element that is not set to display none
        const videoElementForBreakpoint = Array.from(videoElements).find((videoElement) => window.getComputedStyle(videoElement).display !== 'none');
        if (!videoElementForBreakpoint) {
            throw new Error('Video element not found');
        }
        return videoElementForBreakpoint;
    }
}
defineComponent(videoTagName, Video);
